require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./promesa.protocols.js");

require("./promesa.util.js");

require("./promesa.exec.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("promesa.impl.js");
goog.provide('promesa.impl');
promesa.impl._STAR_default_promise_STAR_ = Promise;

promesa.impl.resolved = function promesa$impl$resolved(v) {
  return promesa.impl._STAR_default_promise_STAR_.resolve(v);
};

promesa.impl.rejected = function promesa$impl$rejected(v) {
  return promesa.impl._STAR_default_promise_STAR_.reject(v);
};

promesa.impl.deferred = function promesa$impl$deferred() {
  var state = {};
  var obj = new promesa.impl._STAR_default_promise_STAR_(function (resolve, reject) {
    state.resolve = resolve;
    return state.reject = reject;
  });
  var x22879 = obj;
  x22879.promesa$protocols$ICompletable$ = cljs.core.PROTOCOL_SENTINEL;

  x22879.promesa$protocols$ICompletable$_resolve_BANG_$arity$2 = function (_, v) {
    var ___$1 = this;

    return state.resolve(v);
  };

  x22879.promesa$protocols$ICompletable$_reject_BANG_$arity$2 = function (_, v) {
    var ___$1 = this;

    return state.reject(v);
  };

  return x22879;
};

promesa.impl.extend_promise_BANG_ = function promesa$impl$extend_promise_BANG_(t) {
  t.prototype.promesa$protocols$IPromiseFactory$ = cljs.core.PROTOCOL_SENTINEL;

  t.prototype.promesa$protocols$IPromiseFactory$_promise$arity$1 = function (p) {
    var p__$1 = this;
    return p__$1;
  };

  t.prototype.promesa$protocols$IPromise$ = cljs.core.PROTOCOL_SENTINEL;

  t.prototype.promesa$protocols$IPromise$_map$arity$2 = function (it, f) {
    var it__$1 = this;
    return it__$1.then(function (p1__22880_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(p1__22880_SHARP_) : f.call(null, p1__22880_SHARP_);
    });
  };

  t.prototype.promesa$protocols$IPromise$_map$arity$3 = function (it, f, e) {
    var it__$1 = this;
    return it__$1.then(function (p1__22881_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(p1__22881_SHARP_) : f.call(null, p1__22881_SHARP_);
    });
  };

  t.prototype.promesa$protocols$IPromise$_bind$arity$2 = function (it, f) {
    var it__$1 = this;
    return it__$1.then(function (p1__22882_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(p1__22882_SHARP_) : f.call(null, p1__22882_SHARP_);
    });
  };

  t.prototype.promesa$protocols$IPromise$_bind$arity$3 = function (it, f, e) {
    var it__$1 = this;
    return it__$1.then(function (p1__22883_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(p1__22883_SHARP_) : f.call(null, p1__22883_SHARP_);
    });
  };

  t.prototype.promesa$protocols$IPromise$_then$arity$2 = function (it, f) {
    var it__$1 = this;
    return it__$1.then(function (p1__22884_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(p1__22884_SHARP_) : f.call(null, p1__22884_SHARP_);
    });
  };

  t.prototype.promesa$protocols$IPromise$_then$arity$3 = function (it, f, e) {
    var it__$1 = this;
    return it__$1.then(function (p1__22885_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(p1__22885_SHARP_) : f.call(null, p1__22885_SHARP_);
    });
  };

  t.prototype.promesa$protocols$IPromise$_mapErr$arity$2 = function (it, f) {
    var it__$1 = this;
    return it__$1["catch"](function (p1__22886_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(p1__22886_SHARP_) : f.call(null, p1__22886_SHARP_);
    });
  };

  t.prototype.promesa$protocols$IPromise$_mapErr$arity$3 = function (it, f, e) {
    var it__$1 = this;
    return it__$1["catch"](function (p1__22887_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(p1__22887_SHARP_) : f.call(null, p1__22887_SHARP_);
    });
  };

  t.prototype.promesa$protocols$IPromise$_thenErr$arity$2 = function (it, f) {
    var it__$1 = this;
    return it__$1["catch"](function (p1__22888_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(p1__22888_SHARP_) : f.call(null, p1__22888_SHARP_);
    });
  };

  t.prototype.promesa$protocols$IPromise$_thenErr$arity$3 = function (it, f, e) {
    var it__$1 = this;
    return it__$1["catch"](function (p1__22889_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(p1__22889_SHARP_) : f.call(null, p1__22889_SHARP_);
    });
  };

  t.prototype.promesa$protocols$IPromise$_handle$arity$2 = function (it, f) {
    var it__$1 = this;
    return it__$1.then(function (p1__22890_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$2 ? f.cljs$core$IFn$_invoke$arity$2(p1__22890_SHARP_, null) : f.call(null, p1__22890_SHARP_, null);
    }, function (p1__22891_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$2 ? f.cljs$core$IFn$_invoke$arity$2(null, p1__22891_SHARP_) : f.call(null, null, p1__22891_SHARP_);
    });
  };

  t.prototype.promesa$protocols$IPromise$_handle$arity$3 = function (it, f, e) {
    var it__$1 = this;
    return it__$1.then(function (p1__22892_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$2 ? f.cljs$core$IFn$_invoke$arity$2(p1__22892_SHARP_, null) : f.call(null, p1__22892_SHARP_, null);
    }, function (p1__22893_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$2 ? f.cljs$core$IFn$_invoke$arity$2(null, p1__22893_SHARP_) : f.call(null, null, p1__22893_SHARP_);
    });
  };

  t.prototype.promesa$protocols$IPromise$_finally$arity$2 = function (it, f) {
    var it__$1 = this;
    it__$1.then(function (p1__22894_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$2 ? f.cljs$core$IFn$_invoke$arity$2(p1__22894_SHARP_, null) : f.call(null, p1__22894_SHARP_, null);
    }, function (p1__22895_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$2 ? f.cljs$core$IFn$_invoke$arity$2(null, p1__22895_SHARP_) : f.call(null, null, p1__22895_SHARP_);
    });
    return it__$1;
  };

  return t.prototype.promesa$protocols$IPromise$_finally$arity$3 = function (it, f, executor) {
    var it__$1 = this;
    it__$1.then(function (p1__22896_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$2 ? f.cljs$core$IFn$_invoke$arity$2(p1__22896_SHARP_, null) : f.call(null, p1__22896_SHARP_, null);
    }, function (p1__22897_SHARP_) {
      return f.cljs$core$IFn$_invoke$arity$2 ? f.cljs$core$IFn$_invoke$arity$2(null, p1__22897_SHARP_) : f.call(null, null, p1__22897_SHARP_);
    });
    return it__$1;
  };
};

promesa.impl.extend_promise_BANG_(Promise);
Error.prototype.promesa$protocols$IPromiseFactory$ = cljs.core.PROTOCOL_SENTINEL;

Error.prototype.promesa$protocols$IPromiseFactory$_promise$arity$1 = function (e) {
  var e__$1 = this;
  return promesa.impl.rejected(e__$1);
};

goog.object.set(promesa.protocols.IPromiseFactory, "_", true);
goog.object.set(promesa.protocols._promise, "_", function (v) {
  return promesa.impl.resolved(v);
});

promesa.impl.promise__GT_str = function promesa$impl$promise__GT_str(p) {
  return "#<Promise[~]>";
};

Promise.prototype.cljs$core$IPrintWithWriter$ = cljs.core.PROTOCOL_SENTINEL;

Promise.prototype.cljs$core$IPrintWithWriter$_pr_writer$arity$3 = function (p, writer, opts) {
  var p__$1 = this;
  return cljs.core._write(writer, promesa.impl.promise__GT_str(p__$1));
};

Object.defineProperty(module.exports, "_STAR_default_promise_STAR_", {
  enumerable: false,
  get: function get() {
    return promesa.impl._STAR_default_promise_STAR_;
  }
});
Object.defineProperty(module.exports, "resolved", {
  enumerable: false,
  get: function get() {
    return promesa.impl.resolved;
  }
});
Object.defineProperty(module.exports, "rejected", {
  enumerable: false,
  get: function get() {
    return promesa.impl.rejected;
  }
});
Object.defineProperty(module.exports, "deferred", {
  enumerable: false,
  get: function get() {
    return promesa.impl.deferred;
  }
});
Object.defineProperty(module.exports, "extend_promise_BANG_", {
  enumerable: false,
  get: function get() {
    return promesa.impl.extend_promise_BANG_;
  }
});
Object.defineProperty(module.exports, "promise__GT_str", {
  enumerable: false,
  get: function get() {
    return promesa.impl.promise__GT_str;
  }
});